import { render, staticRenderFns } from "./buyer-seller-city.vue?vue&type=template&id=02cd8e1f"
import script from "./buyer-seller-city.vue?vue&type=script&lang=js"
export * from "./buyer-seller-city.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports